import { NavLink } from 'react-router-dom'
import cashitLogo from '../assets/cashit-logo.svg'
import AccountArea from './AccountArea'

/**
 * The left sidebar: brand, the Cashit attribution, navigation, and the account area pinned to the bottom.
 *
 * The "Powered by" mark is the Cashit logo, bundled with the build rather than hot-linked from
 * cashit.in. A hot-linked logo is a third party's uptime and a third party's request log on every page
 * view of this site, and it breaks the moment cashit.in reorganises its image paths.
 */
export default function Sidebar({ onNewSale, onSignIn }: { onNewSale: () => void; onSignIn: () => void }) {
  return (
    <aside className="sidebar" id="sidebar" aria-label="SellGPT navigation">
      <div className="sidebar-scroll">
        <div className="brand-block">
          <div className="brand">
            <span className="logo" aria-hidden="true">
              ↗
            </span>
            <span>
              sell<strong>gpt</strong>
              <span style={{ color: '#183c2b' }}>.</span>
            </span>
          </div>
          {/* The Cashit mark links to cashit.in, because it is the answer to "who is actually buying my
              phone?" and a customer who wants to check that should not have to type the address. It opens
              in a new tab: this one may hold a half-finished sale, and navigating away from it would
              throw the conversation off screen for the sake of a look at the company. */}
          <a className="powered" href="https://cashit.in/" target="_blank" rel="noopener noreferrer">
            <span>Powered by</span>
            {/* Explicit dimensions: without them the browser cannot reserve the space and the brand
                block jumps when the logo arrives, which Lighthouse counts as layout shift. These are the
                rendered size set in styles.css, not the file's own. */}
            <img src={cashitLogo} alt="Cashit" width="47" height="17" decoding="async" />
          </a>
        </div>

        <button className="new" id="newSale" type="button" onClick={onNewSale}>
          <span aria-hidden="true">＋</span> New sale
        </button>

        <nav aria-label="Main">
          <div className="side-label">Explore</div>
          <NavLink to="/" end className={({ isActive }) => `nav${isActive ? ' active' : ''}`}>
            <span className="ico" aria-hidden="true">
              ✧
            </span>
            Sell a device
          </NavLink>
          <NavLink to="/quotes" className={({ isActive }) => `nav${isActive ? ' active' : ''}`}>
            <span className="ico" aria-hidden="true">
              ▤
            </span>
            My sales
          </NavLink>
          <NavLink to="/how-it-works" className={({ isActive }) => `nav${isActive ? ' active' : ''}`}>
            <span className="ico" aria-hidden="true">
              ⓘ
            </span>
            How it works
          </NavLink>
        </nav>

        <div className="side-bottom">
          <strong>Made for easy selling.</strong>
          <br />
          Sell to Cashit in a conversation.
          {/* The build credit, kept distinct from the Cashit attribution above it: one says who buys the
              device, this one says who wrote the software. Confusing the two would be a claim nobody
              made. */}
          <span className="built-by">
            Powered by{' '}
            <a href="https://reliablesoftech.com/" target="_blank" rel="noopener noreferrer">
              Reliable Software Technology
            </a>
          </span>
        </div>
      </div>

      <AccountArea onSignIn={onSignIn} />
    </aside>
  )
}
